<div class="relative flex h-full flex-nowrap items-center justify-end gap-2xs sm:gap-md">
  <ngx-loadable module="auth-shortcuts" [show]="true" (init)="detectChanges()" class="h-full"></ngx-loadable>
  <bgo-hamburger-menu></bgo-hamburger-menu>
</div>
